<template>
	<v-dialog persistent v-model="show" max-width="500">
		<v-card class="DialogLost">
			<v-card-title>
				<div class="DialogLost_title text-h4">
					You are about to set a lead as lost
				</div>
			</v-card-title>
			<v-card-text>
				<strong class="DialogLost_id" v-if="lead"
					>Lead ID: {{ lead.id }}</strong
				>
				<form>
					<div class="DialogLost_field">
						<label>Reason</label>
						<select v-model="lost_reason">
							<option value="" disabled>Select One</option>
							<option
								v-for="(reason, key) in reasonsType"
								:value="reason.key"
								:key="key"
							>
								{{ reason.value }}
							</option>
						</select>
					</div>
					<div class="DialogLost_field">
						<label for="DialogLost_comment">Comments</label>
						<textarea v-model="lost_comment"></textarea>
					</div>
				</form>
			</v-card-text>
			<v-card-text v-show="showMessage">
				{{ message }}
			</v-card-text>
			<v-card-actions>
				<v-btn color="primary" small @click="handleConfirm"
					>Confirm</v-btn
				>
				<v-btn small @click="handleCancel">Cancel</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { BUS_EVENTS, REASON_TYPE_LOST } from "@/constants";
import { EventBus } from "@/utilities";
import { mapActions } from "vuex";
import { LEAD_STATUSES } from "../constants";

export default {
	name: "DialogLeadLost",
	props: {
		lead: {
			type: Object,
			default: null,
		},
		prevStatus: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			show: false,
			showMessage: false,
			message: "All fields are requiered",
			lost_comment: "",
			lost_reason: "",
			reasonsType: null,
		};
	},
	methods: {
		...mapActions(["saveExtraLeads", "saveExtraVisitors"]),
		handleCancel() {
			// this.lead = null;
			this.show = false;
			EventBus.$emit(BUS_EVENTS.LEAD_LOST, null);
			EventBus.$emit(BUS_EVENTS.LEAD_LOST_CANCELED);
		},
		async handleConfirm() {
			this.showMessage = false;

			if (
				this.lost_comment.trim().length == 0 ||
				this.lost_reason == ""
			) {
				console.log("Please fill all form fields and confirm.");
				//EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED , { type: 'error', message: 'Please fill all form fields and confirm.', duration: 2e3 });
				this.showMessage = true;
				return false;
			} else {
				const extrafields = new FormData();
				if (this.lead.type === "in-bound") {
					extrafields.append("lead_id", this.lead.id);
				} else {
					extrafields.append("visualvisitor_id", this.lead.id);
				}
				extrafields.append("status", LEAD_STATUSES.LOST);
				extrafields.append("lost_reason", this.lost_reason);
				extrafields.append("lost_comment", this.lost_comment);
				extrafields.append("save_history", true);

				try {
					if (this.lead.type === "in-bound") {
						const lead_extra_id = await this.saveExtraLeads(
							extrafields
						);
					} else {
						const visualvisitor_extra_id =
							await this.saveExtraVisitors(extrafields);
					}

					EventBus.$emit(BUS_EVENTS.LEAD_LOST_SAVED);

					EventBus.$emit(BUS_EVENTS.LEAD_LOST, null);
					EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
						type: "success",
						message: "Lead turned LOST",
						duration: 2e3,
					});
					EventBus.$emit(BUS_EVENTS.STATS_UPDATED);

					this.showMessage = false;
					(this.show = false), (this.lost_comment = "");
					this.lost_reason = null;
				} catch (error) {
					console.error(err.response.status);
					EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
						type: "error",
						message:
							"Lead cannot be turned LOST. Please try again later.",
						duration: 2e3,
					});
				}
			}
		},
	},
	watch: {
		lead(val) {
			if (val) {
				this.show = true;
				this.reasonsType = REASON_TYPE_LOST;
			} else {
				this.reasonsType = null;
				this.show = false;
			}
		},
		lost_comment(newValue) {
			if (newValue.trim().length > 0) this.showMessage = false;
		},
		lost_reason(newValue) {
			if (newValue !== "") this.showMessage = false;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";
.DialogLost {
	.DialogLost_title {
		font-size: 24px !important;
		line-height: 1;
		color: $purple;
		word-wrap: normal !important;
	}
	&_id {
		display: block;
		margin: 10px 0;
	}
	&_field {
		display: block;
		margin-bottom: 10px;
		label {
			display: block;
		}
		select {
			font-size: 13px;
			background: url("~@/assets/img/arrow-select1.svg") #ffffff no-repeat
				right 10px center;
			display: block;
			width: 100%;
			max-width: 100%;
			height: 30px;
			padding: 0 10px;
			border: 1px solid;
			border-radius: 6px;
		}
		textarea {
			display: block;
			width: 100%;
			height: auto;
			min-height: 100px;
			padding: 10px;
			border: 1px solid;
			border-radius: 6px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/DialogLeadLost.vue